import { createFileRoute } from "@tanstack/react-router";

import { ItemPage } from "../../../workspaces/library/pages/ItemPage";

export const Route = createFileRoute("/_console/p/$org/$project/library/items/$name")({
  component: ItemRoute,
});

/** One catalog record — a model, a robot, a world — on its own page. */
function ItemRoute() {
  const { name } = Route.useParams();
  return <ItemPage name={name} />;
}
